import { z } from "zod";
import { oc } from "@orpc/contract";
//#region src/api/orpc/auth/forgetPassword.ts
const sendForgetPasswordCodeRoute = oc.route({
	method: "POST",
	path: "/forget-password/send-code",
	summary: "Send a verification code to the given email so the user can reset their password"
}).input(z.object({ email: z.string().email() })).output(z.void());
const resetForgetPasswordRoute = oc.route({
	method: "POST",
	path: "/forget-password/reset",
	summary: "Reset the password for the given email using the verification code"
}).input(z.object({
	email: z.string().email(),
	code: z.string().min(1),
	password: z.string().min(1).max(200)
})).output(z.void());
//#endregion
export { resetForgetPasswordRoute, sendForgetPasswordCodeRoute };
